<template>
    <div class="form-entry row row-cols-1" v-if="formTemplate">

        <div class="col">
            <h1 class="text-left">Edit a Form Template</h1>
        </div>

        <div class="col">
            <div class="form-entry__section-explanation">
                <h4><div class="form-entry__section-explanation-number">1</div> Edit the <b>Welcome</b> and <b>Thank You</b> text</h4>
            </div>
        </div>

        <template v-if="isFrontDeskForm">
            <div class="col">Front desk forms do not show welcome and thank you messages</div>
        </template>

        <template v-else>
            <div class="col form-entry__section-explanation">
                <h5>Welcome message</h5>
            </div>

            <div class="col">
                <div class="card summary form-title">
                    <div class="card-header">
                        <div class="title__actions">
                            <ul><li v-on:click="editTitle"><i v-on:click="editTitle" class="fas fa-edit"></i></li></ul>
                        </div>
                        <div v-if="hasHeader" class="text-center"><img v-bind:src="headerImageURL"></div>
                        <div v-else>Upload and choose a page header image</div>
                        <div class="media-body text-center">
                            <h2 v-if="formTemplate.title" class="card-title">
                                {{formTemplate.title}}
                            </h2>
                            <div v-else>Upload and choose a page header image</div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="form-title__message">
                            <div v-if="formTemplate.welcomeMessage" v-bind:inner-html.prop="formTemplate.welcomeMessage | marked"></div>
                            <div v-else>Enter your welcome message that the client reads before filling in this form</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col form-entry__section-explanation">
                <h5>Thank you message</h5>
            </div>

            <div class="col">
                <div class="card summary form-title">
                    <div class="card-header">
                        <div class="title__actions">
                            <ul><li v-on:click="editThankYou"><i class="fas fa-edit"></i></li></ul>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="form-title__message">
                            <div v-if="formTemplate.thankYouMessage" v-bind:inner-html.prop="formTemplate.thankYouMessage | marked"></div>
                            <div v-else>Enter your thank you message shown after the form has been completed</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div class="col">
            <div class="form-entry__section-explanation">
                <h4><div class="form-entry__section-explanation-number">2</div>
                Edit the <b>Form</b></h4>
            </div>
        </div>

        <div class="col">
            <div v-if="formTemplate.sections.length === 0" class="card section question__placeholder">
                <div>
                    <a href="#">
                        <div v-on:click="addSection(formTemplate.reference, 0)" class="section__add section__add--top">+</div>
                    </a>
                </div>
                <div>
                    <a href="#">
                        <div v-on:click="addSection(formTemplate.reference, 0)" class="section__add section__add--bottom">+</div>
                    </a>
                </div>
                Click / tap to add a section
            </div>

            <Draggable v-model="formTemplate.sections" group="sections" @start="movingSection=true" @change="movedSection" @end="movingSection=false" v-bind:disabled="disableDragging">
                <FormSectionTemplate v-for="(section, index) in formTemplate.sections"
                             v-bind:formTemplateReference="formTemplate.reference"
                             v-bind:section="section"
                             v-bind:index="index"
                             v-bind:key="section.reference"
                             v-bind:movingSection="movingSection"></FormSectionTemplate>
            </Draggable>

            <div v-if="editing">
                <EditTitle v-bind:formTemplate="formTemplate" v-bind:editingThankYou="editingThankYou"></EditTitle>
            </div>
        </div>

    </div>
</template>

<script>
    import Draggable from 'vuedraggable'

    import { store, getters } from '../store.js'
    import EditTitle from "../components/forms/EditTitle";
    import FormSectionTemplate from "../components/forms/FormSectionTemplate";
    // import {ValidationObserver} from "vee-validate";

    export default {
        name: 'EditFormTemplate',
        // components: {FormSectionTemplate, ValidationObserver},
        components: {Draggable, EditTitle, FormSectionTemplate},
        // components: { FormSectionTemplate},
        data: function () {
            return {
                formTemplate: null,
                editing: false,
                editingThankYou: false,
                movingSection: false,
                disableDragging: false
            }
        },
        computed: {
            isFrontDeskForm: function() {
                return this.formTemplate && this.formTemplate.type === 'front-desk';
            },
            hasHeader: function() {
                return getters.doesCurrentEstablishmentHaveHeaderImage();
            },
            headerImageURL: function() {
                return getters.getCurrentEstablishmentHeaderImage().url;
            }
        },
        methods: {
            editTitle: function () {
                this.editingThankYou = false;
                this.editing = true;
            },
            editThankYou: function () {
                this.editingThankYou = true;
                this.editing = true;
            },
            addSection: function (formReference, index) {
                if (this.formTemplate.reference === formReference) {
                    console.log("adding section to this form");
                    this.formTemplate.sections.splice(index, 0, { type: 'stay-information', questions: [] });
                    setTimeout(() => {
                        this.$root.$emit('edit-new-section', formReference, index);
                    }, 500);
                }
            },
            startMovingSection: function() {
                this.movingSection = true;
            },
            movedSection: function (event) {
                console.log("Moved: " + this.formTemplate.reference + "::");
                console.log(event);
                let body = {};
                if (event.moved) {
                    body = {
                        reference: event.moved.element.reference,
                        index: event.moved.newIndex
                    };
                    console.log("Change ordering...");
                } else if (event.added) {
                    console.log("This should not be called...");
                }
                if (event.moved) {
                    this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                        + '/form-templates/' + this.formTemplate.reference + "/move-section", body
                    ).then(response => {
                        console.log("Section moved. Response: ");
                        console.log(response)
                    }).catch(error => {
                        if (error.response) {
                            this.error = error.response.data.message
                        } else {
                            this.error = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    });
                    console.log("Moved section...");
                }
            },
            deleteSection: function(formReference, index) {
                if (this.formTemplate.reference === formReference) {
                    console.log("deleting section from this form");
                    this.formTemplate.sections.splice(index, 1);
                }
            },
            editingSectionOrQuestion: function() {
                this.disableDragging = true;
            },
            stopEditingSectionOrQuestion: function() {
                this.editing = false;
                this.disableDragging = false;
            },
        },
        mounted () {
            const formTemplateReference = this.$route.params.reference
            this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/form-templates/' + formTemplateReference).then(response => {
                this.formTemplate = response.data
            }).catch(error => {
                console.log(error)
            });

            this.$root.$on('moving-section', this.startMovingSection);
            this.$root.$on('editing-section-or-question', this.editingSectionOrQuestion);
            this.$root.$on('finished-editing-section-or-question', this.stopEditingSectionOrQuestion);
            this.$root.$on('add-section-to-form', this.addSection);
            this.$root.$on('delete-section-from-form', this.deleteSection);
        },
        beforeDestroy () {
            this.$root.$off('moving-section', this.startMovingSection);
            this.$root.$off('editing-section-or-question', this.editingSectionOrQuestion);
            this.$root.$off('finished-editing-section-or-question', this.stopEditingSectionOrQuestion);
            this.$root.$off('add-section-to-form', this.addSection);
            this.$root.$off('delete-section-from-form', this.deleteSection);
        }
    }
</script>
<style lang="scss" scoped>
    @import "../styles/pages/view-form";
    @import "../styles/pages/edit-form";
    @import "../styles/components/question_answer";
</style>